<template>
    <div class="select-page" >
    
        <div class="seach-bar">

            <div class="container-svg-serach">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                    <path d="M17.0625 8.53125C17.0625 10.4139 16.4514 12.1529 15.4219 13.5639L20.6145 18.7605C21.1271 19.2732 21.1271 20.1059 20.6145 20.6186C20.1018 21.1312 19.2691 21.1312 18.7564 20.6186L13.5639 15.4219C12.1529 16.4555 10.4139 17.0625 8.53125 17.0625C3.81855 17.0625 0 13.2439 0 8.53125C0 3.81855 3.81855 0 8.53125 0C13.2439 0 17.0625 3.81855 17.0625 8.53125ZM8.53125 14.4375C9.30687 14.4375 10.0749 14.2847 10.7915 13.9879C11.5081 13.6911 12.1592 13.256 12.7076 12.7076C13.256 12.1592 13.6911 11.5081 13.9879 10.7915C14.2847 10.0749 14.4375 9.30687 14.4375 8.53125C14.4375 7.75563 14.2847 6.9876 13.9879 6.27103C13.6911 5.55445 13.256 4.90335 12.7076 4.3549C12.1592 3.80645 11.5081 3.3714 10.7915 3.07459C10.0749 2.77777 9.30687 2.625 8.53125 2.625C7.75563 2.625 6.98761 2.77777 6.27103 3.07459C5.55445 3.3714 4.90335 3.80645 4.3549 4.3549C3.80645 4.90335 3.3714 5.55445 3.07459 6.27103C2.77777 6.9876 2.625 7.75563 2.625 8.53125C2.625 9.30687 2.77777 10.0749 3.07459 10.7915C3.3714 11.5081 3.80645 12.1592 4.3549 12.7076C4.90335 13.256 5.55445 13.6911 6.27103 13.9879C6.98761 14.2847 7.75563 14.4375 8.53125 14.4375Z" fill="#E3D2EE"/>
                </svg>
            </div>
            <input v-model.lazy="valueInputSearch">
            <i class="fa-solid fa-bars-filter" @click="showFilter"></i>

            <div class="container-filter" ref="filterSelectPage" v-if="displayFilter">
                <div class="filter">
                    <div class="container-title">
                        <h5>{{ $t('dash.select-page.account-type') }}</h5>
                        <p v-if="Object.keys(Networks).length == SelectNetwork.length" @click="removeAllNetwork">{{ $t('dash.posts.filter.hide-all') }}</p>
                        <p v-else @click="addAllNetwork">{{ $t('dash.posts.filter.show-all') }}</p>
                    </div>
                    <div class="list-reseaux">
                        <div class="reseau" v-for="(networkKey,index) in Object.keys(Networks)" :key="index">
                            <Checkbox :isChecked="SelectNetwork.includes(networkKey)" :add="addNetwork" :remove="removeNetwork" :id="prefixIdChecbox+'FilterSelectPage-'+networkKey"></Checkbox>
                            <img :src="Networks[networkKey].urlPicture">
                            <p>{{ Networks[networkKey].label}}</p>
                        </div>    
                    </div>
                </div>
            </div>
        </div>
      
        <div class="container-list">
             <details>
                <summary :class="{disable: isFreezed && stateCheckboxAllPage !== 'none'}">
                    <Checkbox :isChecked="stateCheckboxAllPage !== 'none'" :isLine="stateCheckboxAllPage == 'partial'" :isDisable="isFreezed" :add="addAllPage" :remove="removeAllPage" :id="'addAllPage'" :prefixId="prefixIdChecbox"></Checkbox>
                    <p>{{ $t('dash.pages.group.all_pages') }}</p>
                </summary>
            </details>
          
            <details v-for="(group, groupId) in dataView.groups" :key="groupId" :open="forceOpenAllGroups || valueInputSearch !== '' || openGroups[groupId] || openGroups[groupId] == undefined" @toggle="onToggleGroup($event, groupId)"> 
                <summary :class="{disable: isFreezed && (!selectedGroups[groupId] || selectedGroups[groupId] == 'none')}">
                    <Checkbox 
                        :isChecked="selectedGroups[groupId] && selectedGroups[groupId] !== 'none'" 
                        :isDisable="isFreezed"
                        :isLine="selectedGroups[groupId] && selectedGroups[groupId] == 'partial'" 
                        :add="addSelectGroup" 
                        :remove="removeSelectGroup" 
                        :id="groupId" :prefixId="prefixIdChecbox"
                    />
                    <p>{{group.name}}</p>
                    <i class="fa-solid fa-caret-right"></i>
                </summary>
                
             
                <label class="page" :class="{disable: isFreezed && !selectedPages[pageId]}" v-for="pageId in group.pages" :key="pageId">
                    <template v-if="allPages[pageId]">
                        <Avatar :urlPicture="allPages[pageId].avatar" :typeNetwork="allPages[pageId].network" :checked="selectedPages[pageId]"></Avatar>
                        
                        <Tooltip :text="allPages[pageId].name" :condition="(element)=>(element.querySelector('p').offsetWidth < element.querySelector('p').scrollWidth)">
                            <p class="selectDisable">
                                {{allPages[pageId].name}}
                                <!-- <i class="fa-solid fa-fire-flame-curved" v-if="allPages[pageId].natifMode"></i> -->
                                <i class="fa-solid fa-bell-concierge" v-if="allPages[pageId].natifMode"></i>
                            </p>
                        </Tooltip>
                        
                        <Checkbox 
                            :isChecked="selectedPages[pageId]" 
                            :isDisable="isFreezed" 
                            :add="addSelectPage" 
                            :remove="removeSelectPage" 
                            :id="pageId" 
                            :prefixId="prefixIdChecbox">
                        </Checkbox>
                    </template>
                </label>
                
            </details>

            
            <label class="otherPage" :class="{disable: isFreezed && !selectedPages[pageId]}" v-for="(page, pageId) in dataView.otherPage" :key="pageId">
                <Avatar :urlPicture="page.avatar" :typeNetwork="page.network" :checked="selectedPages[pageId]"></Avatar>

                <Tooltip :text="page.name" :condition="(element)=>(element.querySelector('p').offsetWidth < element.querySelector('p').scrollWidth)">
                    <p class="selectDisable">
                        {{page.name}}
                        <!-- <i class="fa-solid fa-fire-flame-curved" v-if="allPages[pageId].natifMode"></i> -->
                        <i class="fa-solid fa-bell-concierge" v-if="allPages[pageId].natifMode"></i>
                    </p>
                </Tooltip>

                <Checkbox :isChecked="selectedPages[pageId]" :isDisable="isFreezed" :add="addSelectPage" :remove="removeSelectPage" :id="pageId" :prefixId="prefixIdChecbox"></Checkbox>
            </label>

        </div>
    </div>
</template>

<script>
import Checkbox from './utils/checkbox.vue';
import Avatar from './utils/avatar.vue';
import Tooltip from './tooltip/tooltipInit.vue';
import store from './../../store/index.js';

const LIST_NETWORK = ['facebook','linkedin','pagesFacebook','tiktok','google','youtube','instagram','pinterest','twitter','telegram', 'threads', 'whatsapp', 'bluesky']
export default {
    name: 'selectPage',

    components: {
        Checkbox,
        Avatar,
        Tooltip
    },

    props: {
        groups : Array,

        allPages : Object,

        SelectPageProp : {
            type: Array,
            default() {
                return []
            }
        },

        forceOpenAllGroups : {
            type: Boolean,
            default() {
                return false
            }
        },

        id: String,

        isFreezed: {
            type: Boolean,
            default() {
                return false
            }
        }

  
    },
    
    data() {
        return {
            SelectNetwork : LIST_NETWORK,
            displayFilter : false,
            valueInputSearch : "",
            
            Networks: {
                'facebook' : {
                    label : "Facebook",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-facebook.png')
                },
                // 'groupesFacebook' : {
                //     label : "Groupes",
                //     urlPicture : require('../../assets/img/iconsNetwork/ico-facebook.png')
                // },
                'linkedin' : {
                    label : "Linkedin",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-linkedin.png')
                },
                'pagesFacebook' : {
                    label : "Pages",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-facebook.png')
                },
                'tiktok' : {
                    label : "Tiktok",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-tiktok.png')
                },
                'google' : {
                    label : "My business",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-google.png')
                },
                'youtube' : {
                    label : "Youtube",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-youtube.png')
                },
                'threads' : {
                    label : "Threads",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-threads.png')
                },
                'instagram' : {
                    label : "Instagram",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-instagram.png')
                },
                'pinterest' : {
                    label : "Pinterest",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-pinterest.png')
                },
                'twitter' : {
                    label : "Twitter",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-twitter.png')
                },
                'telegram' : {
                    label : "Telegram",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-telegram.png')
                },
                'whatsapp' : {
                    label : "WhatsApp",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-whatsapp.png')
                },
                'bluesky' : {
                    label : "Bluesky",
                    urlPicture : require('../../assets/img/icon_bluesky.png')
                },
            },

            SelectPage : [],
            openGroups : {},
            prefixIdChecbox : parseInt(Math.random() * (999 - 100) + 100).toString(),

            data: {
                groups: {

                },
                otherPage: {

                }
            },

            dataView: {
                groups: {

                },
                otherPage: {

                }
            },
            

            selectedGroups:{

            },

            selectedPages:{

            }
            
        };
    },

   
 
    mounted () {
      
        this.SelectPage = this.SelectPageProp

        if (this.id && localStorage.getItem(`openGroupsSelectPage_${this.id}`)) {
            this.openGroups = JSON.parse(localStorage.getItem(`openGroupsSelectPage_${this.id}`))
        }

   
        
    },

    methods: {
        generateData() {
            console.log('generateData start s',JSON.parse(JSON.stringify( this.groups)))
            let allPages = this.allPages
            let groups = this.groups

            let otherPage = Object.values(allPages).reduce((acc, page) => {
                if (!page.groups || !page.groups.length) {
                    acc[page.id] = page;
                }
                return acc;
            }, {});

            this.data = { groups, otherPage }
            this.generateDataView()
            console.log('generateData end')
        },

        generateDataView() {
            console.log('generateDataView')
            const searchValue = this.valueInputSearch ? this.valueInputSearch.trim().toLowerCase() : ''
            const selectNetworkChanged = this.SelectNetwork.length !== LIST_NETWORK.length
            const dataDefault = JSON.parse(JSON.stringify(this.data))
            
            if (!searchValue && !selectNetworkChanged) {
                this.dataView = dataDefault
            }else{
                let groups = Object.values(dataDefault.groups).reduce((acc, group) => {
                    group.pages = group.pages.filter(pageId => {
                        return this.allPages[pageId] && (!selectNetworkChanged || this.SelectNetwork.includes(this.allPages[pageId].network)) && (this.allPages[pageId].name.trim().toLowerCase().indexOf(searchValue) >= 0 ||  this.allPages[pageId].network.indexOf(searchValue) >= 0)
                    })
                    if (group.pages.length) acc[group.id] = group
                    return acc
                },{})

                let otherPage = Object.values(dataDefault.otherPage).reduce((acc, page) => {
                    console.log('otherPage page',page,page.name.trim().toLowerCase(), searchValue , page.name.trim().toLowerCase().indexOf(searchValue))
                    if ((!selectNetworkChanged || this.SelectNetwork.includes(page.network)) && (page.name.trim().toLowerCase().indexOf(searchValue) >= 0 ||  page.network.indexOf(searchValue) >= 0)) {
                        acc[page.id] = page
                    }
                    return acc
                },{})

                this.dataView = {groups,otherPage}
            }

    
            //parconir tout les page
        },

        findGroup(idGroup) {
            return this.data.groups[idGroup] || null
        },

        //EVENT CHECKBOX list Page & Group
        addAllPage() {
            this.selectedPages = Object.keys(this.allPages).reduce((acc, pageId) => {
                acc[pageId] = true;
                return acc;
            }, {});

            this.selectedGroups = Object.keys(this.data.groups).reduce((acc, pageId) => {
                acc[pageId] = 'all';
                return acc;
            }, {});
            this.$emit('updateSelectPage', Object.keys(this.selectedPages))
        },
    
        removeAllPage() {
            this.selectedPages = {}
            this.selectedGroups = {}
            this.$emit('updateSelectPage', Object.keys(this.selectedPages))
        },

        addSelectPage(idPage) {
            console.log('addSelectPage',idPage)
            if (!this.selectedPages[idPage] && this.allPages[idPage]) {
                this.$set(this.selectedPages, idPage, true)
                if (this.allPages[idPage].groups) {
                    this.calculGroups([...new Set(this.allPages[idPage].groups)])
                }
                this.$emit('updateSelectPage', Object.keys(this.selectedPages))
            }
        },

        removeSelectPage(idPage) {

            if (this.selectedPages[idPage]) {
                this.$delete(this.selectedPages, idPage)
                if (this.allPages[idPage].groups) {
                    this.calculGroups([...new Set(this.allPages[idPage].groups)])
                }
                this.$emit('updateSelectPage', Object.keys(this.selectedPages))
            }
        },
        
        addSelectGroup(idGroup) {
            console.log('addSelectGroup',idGroup)
            const group = this.findGroup(idGroup);
            let groupsNeedCalculed = []
            if (group) {
                group.pages.forEach((idPage) => {
                    
                    if (!this.selectedPages[idPage]) {
                        this.$set(this.selectedPages, idPage, true)
                        console.log(this.allPages[idPage].name, this.allPages[idPage].groups)
                        if (this.allPages[idPage].groups) {
                            groupsNeedCalculed = groupsNeedCalculed.concat(this.allPages[idPage].groups)
                        }
                    }
                    
                }) 
                this.$emit('updateSelectPage', Object.keys(this.selectedPages))
            }
            console.log('groupsNeedCalculed',groupsNeedCalculed)
            this.calculGroups([...new Set(groupsNeedCalculed)])
        },

        removeSelectGroup(idGroup) {
            const group = this.findGroup(idGroup);
            let groupsNeedCalculed = []
            if (group) {
                group.pages.forEach((idPage) => {
                    if (this.selectedPages[idPage])  {
                        this.$delete(this.selectedPages, idPage)
                        if (this.allPages[idPage].groups) {
                            groupsNeedCalculed = groupsNeedCalculed.concat(this.allPages[idPage].groups)
                        }
                    }
                }) 
                this.$emit('updateSelectPage', Object.keys(this.selectedPages))
            }
            this.calculGroups([...new Set(groupsNeedCalculed)])
        },
   
        syncPageSelection() {
            
            console.log('syncPageSelection',Object.keys(this.data.groups))
            this.selectedPages = Object.fromEntries(this.SelectPage.map(page => [page.id, true]));
            console.log('syncPageSelection this.selectedPages',this.selectedPages, this.SelectPage)
            this.calculGroups(Object.keys(this.data.groups))
        },

        //gourmand
        calculGroups(groupsIds) {
            console.log('calculGroups |', groupsIds, '|',this.selectedPages)
            let group, lengthPageSelected
            groupsIds.forEach(groupId => {
                group = this.findGroup(groupId)
                if (group) {
                    lengthPageSelected = group.pages.filter((pageId) => this.selectedPages[pageId]).length
                    let state;
                    console.log('calculGroups', group.name, lengthPageSelected, group.pages.length)
                    if (lengthPageSelected == 0) state = 'none'
                    else if (lengthPageSelected == group.pages.length) state = 'all'
                    else state = 'partial'

                    if (this.selectedGroups[groupId] !== state) {
                        this.$set(this.selectedGroups, groupId, state)
                    }
                }
            });
        },

        //EVENT Filter
        addAllNetwork() {
            this.SelectNetwork = Object.keys(this.Networks);
            this.generateDataView()
        },

        removeAllNetwork() {
            this.SelectNetwork = [];
            this.generateDataView()
        },

        addNetwork(name) {
            name = name.split('-')[1]  // name FilterSelectPage-linkedin or FilterSelectPage-instagram ...
            if(!this.SelectNetwork.includes(name)) {
                this.SelectNetwork.push(name)
                this.generateDataView()
            }

        },
        
        removeNetwork(name) {
            this.SelectNetwork = this.SelectNetwork.filter(nameNetwork => nameNetwork !== name.split('-')[1])
            this.generateDataView()
        },

        showFilter(e) {
            e.stopPropagation();
            this.displayFilter = true;
            window.addEventListener("click", this.handleClickOutside);
        },

        handleClickOutside(event) {
            const targetElement = this.$refs.filterSelectPage;
            if (!targetElement.contains(event.target)) {
                window.removeEventListener("click", this.handleClickOutside, false);
                this.displayFilter = false;
            }
        },

        onToggleGroup(e,groupId) {
            if (!this.valueInputSearch && !this.forceOpenAllGroups) {
                this.$set(this.openGroups, groupId, e.target.open)
            }

            if (this.id) {
                localStorage.setItem(`openGroupsSelectPage_${this.id}`, JSON.stringify(this.openGroups))
            }
           
        },   
    },

    computed: {
        allPagesLength() {
            return Object.keys(this.allPages).length
           
        },

        stateCheckboxAllPage() {

            const countSelectedPages = Object.keys(this.selectedPages).length
            console.log("stateCheckboxAllPage", countSelectedPages)
            if (!countSelectedPages) return 'none'
            if (this.allPagesLength == countSelectedPages) return 'all'
            return 'partial'
        },

    },

    watch: {
        groups: {
            immediate: true,
            deep: true,
            handler(newValue, oldValue) {
                this.generateData()
                this.syncPageSelection()
            }
        },

        //retirer car le store met a jour groups en dernier
        // allPages: {
        //     immediate: true,
        //     deep: true,
        //     handler(newValue, oldValue) {
        //         this.generateData()
        //         this.syncPageSelection()
        //     }
        // },
        
        SelectPageProp: {
            immediate: true,
            handler(newValue, oldValue) {
                console.log('watch SelectPageProp',this.SelectPageProp)
                if (this.SelectPageProp.length !== this.SelectPage.length) {
                    this.selectedPages = this.SelectPageProp.reduce((acc, idPage) => {
                        if(idPage) acc[idPage] = true
                        return acc
                    }, {})
                    
                    this.SelectPage = this.SelectPageProp
                    this.syncPageSelection()
                }
            }
        },
        
    

        valueInputSearch() {
            this.generateDataView()
        },
        selectedPages() {
            //this.$emit('updateSelectPage', Object.keys(this.selectedPages))
        }
    },
    beforeDestroy() {
        window.removeEventListener("click", this.handleClickOutside);

        if (this.id) {
            localStorage.setItem(`openGroupsSelectPage_${this.id}`, JSON.stringify(this.openGroups))
        }
    },
   
};
</script>